<section class="plan-selection-section" [ngClass]="{ 'v2': isV2 }">
  <div class="header-container">
    <button
      *ngIf="!hideBackButton"
      mat-button
      class="back-button"
      (click)="goBackToWidgetsCenter()"
      aria-label="back button"
      [ngClass]="{ 'v2': isV2 }">
      <mat-icon>arrow_back</mat-icon>
      <span class="back-text desktop-only">{{ 'common.back' | translate }}</span>
    </button>
    <h6 class="typography-h6 pricing-and-plans-text mobile-only" *ngIf="isV2">{{
      (useCardEntryExperimentTitle ? 'billing.choosePlanToAddCard' : 'billing.pricingAndPlans') | translate
    }}</h6>
  </div>

  <app-choose-plan
      *ngIf="!hasExistingPaymentMethod; else upgradeDowngradePlan"
      [currentPlan]="currentPlan"
      [isV2]="isV2"
      [useCardEntryExperimentTitle]="useCardEntryExperimentTitle"
    >
  </app-choose-plan>
  <ng-container *ngIf="isV2">
    <app-plan-comparison
      [currentPlan]="currentPlan"
      (planChanged)="goBackToWidgetsCenter()"
      *ngIf="isV2">
    </app-plan-comparison>

    <!-- Addons Section -->
    <section class="addons-section" *ngIf="addonsPageService.addonsPageEnabled$ | async">
      <app-addons-center
        [isSummary]="true"
        [isChoosePlanPage]="true"
        [currentPlan]="currentPlan"
        (addonChange)="handleAddonChange()"
      ></app-addons-center>
    </section>

    <section class="faq-section">
      <app-pricing-faqs-widget
        billingWidget="full-width"
        [pricingPlan]="(billingData)?.billingDetails?.currentPlanId"
      ></app-pricing-faqs-widget>
    </section>
  </ng-container>
</section>

<ng-template #upgradeDowngradePlan>
  <app-upgrade-downgrade-plan
    [currentPlan]="currentPlan"
    (planChanged)="goBackToWidgetsCenter()"
    [isV2]="isV2"
    [ngClass]="{ 'v2': isV2 }"
  ></app-upgrade-downgrade-plan>
</ng-template>
